import { Injectable } from "@angular/core";
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

@Injectable()
export class Helpers {

    public static valorMask: any = createNumberMask({
        prefix: '',
        suffix: ' R$'
    });
    public static dddMask: any[] = [/\d/, /\d/];
    public static codigo_controleMask: any[] = [/[A-z]*/, /[A-z]*/, /[A-z]*/, /[A-z]*/, /[A-z]*/, /[A-z]*/, /[A-z]*/, /[A-z]*/, /[A-z]*/, /[A-z]*/];
    public static cnaipjMask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    public static cepMask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
    public static telefoneMask: any[] = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/];
    public static celularMask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; 
    public static telefoneDddMask: any[] = [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; 
    public static registroMask: any[] = [/[A-z]/, /[A-z]/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '/', /[o|tO|T]/];
    public static protocoloMask: any[] = [/[A-z]/, /[A-z]/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
    public static cpfMask: any[] = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public static cnpjMask: any[] = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    public static onlyDigits: RegExp = /\D/g;
    public static dateValidation: RegExp = /(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})/;
    public static cpfValidation: RegExp = /^(\d{3}.\d{3}.\d{3}-\d{2})|(\d{11})/;
    public static cnpjValidation: RegExp = /^(\d{2}.\d{3}.\d{3}\/\d{4}-\d{2})|(\d{14})/;
}

// (A|a)(C|c|L|l|M|m|P|p)|BA|ba|CE|ce|DF|df|ES|es|GO|go|(M|m)(A|a|G|g|S|s|T|t)|(P|p)(A|a|B|b|E|e|I|i|R|r)|(R|r)(J|j|N|n|O|o|R|r|S|s)|(S|s)(C|c|E|e|P|p|)|TO|to


// WEBPACK FOOTER //
// ./src/app/util/helpers.ts